import Card from 'react-bootstrap/Card';
import './components.css';
import React from 'react'
import { BsGithub } from 'react-icons/bs';
import {GrLinkedin} from 'react-icons/gr';
import {SiAmazonaws} from 'react-icons/si';
import {SiCisco, SiRobotframework} from 'react-icons/si'

function AboutMe() {
  return (

    <div class="aboutme">

    <Card style={{ width: '25rem' }} className="mb-5 mt-5 pt-4">
      <Card.Body>
        {/* <Card.Title >Card Title</Card.Title> */}
        <div class="full-name">Takako Onozuka</div>

        <p class="h3">Junior Software Developer</p>

        <div class="button-container-language">
        <button type="button" class="btn btn-info mb-2">Java</button>
        <button type="button" class="btn btn-info mb-2">JavaScript</button>
        <button type="button" class="btn btn-info mb-2">Python</button>
        <button type="button" class="btn btn-info mb-2">CSS</button>
        {/* </div>
        <div class="button-container-others"> */}
        <button type="button" class="btn btn-info mb-2">MySQL</button>
        <button type="button" class="btn btn-info mb-2">MongoDB</button>
        <button type="button" class="btn btn-info mb-2">React</button>
        <button type="button" class="btn btn-info mb-2">Spring</button>
        <button type="button" class="btn btn-info mb-2">Agile</button>
        <button type="button" class="btn btn-info mb-2">TDD</button>
        <button type="button" class="btn btn-info mb-2">Test Automation</button>
        </div>

        <div class="link-container">
       
        <Card.Link class="github-link" href="https://github.com/taksgarby" target="_blank"> 
        <BsGithub /> Github</Card.Link>
        <Card.Link class="linkedin-link" href="https://www.linkedin.com/in/t-onozuka/" target="_blank">
        <GrLinkedin /> LinkedIn</Card.Link>
        </div>
   
        <div class="link-container">
        <Card.Link class="aws-link" href="https://aws.amazon.com/certification/certified-cloud-practitioner/" target="_blank"> 
        <SiAmazonaws /> AWS Certified Cloud Practitioner</Card.Link>
        </div>

        <div class="link-container">
        <Card.Link class="cisco-link" href="https://www.netacad.com/courses/cybersecurity/introduction-cybersecurity" target="_blank"> 
        <SiCisco /> CISCO Introduction to Cybersecurity </Card.Link>
        </div>

        <div class="link-container">
        <Card.Link class="robot-link" href="https://robocorp.com/docs/courses/work-data-management" target="_blank"> 
        <SiRobotframework /> Robocorp Robotic Process Automation Level 3 </Card.Link>
        </div>

        <div class="news">
          Please visit my fictional e-commerce site, <a href="https://taksgarby.github.io/curiositymugs/" target="_blank">
           <strong> Curiosity Mugs</strong></a>. All the images are generated by me with the help of AI. 
        </div>
      </Card.Body>
    </Card>

    <Card style={{ width: '30rem' }} className="m-5">
        <Card.Body>
          {/* <Card.Title >Card Title</Card.Title> */}
          <div class="aboutme-right">
          <p class="aboutme-texts">
                
            </p>
  
            <p class="aboutme-headline">
                About Takako
            </p>
            <p class="aboutme-texts">
                Originally from Japan, I worked in Tokyo's publishing sector before moving to Scotland. 
                For the past 10 years, I have worked in education, teaching literacy to young people all over 
                Scotland at a weekend Japanese high school. Both experiences trained me to be a detail oriented content creator. 
                I have decided to shift my career into software development in recent years, and I love coding and working in Agile-style teamwork.            </p>
            <p class="aboutme-headline">
                Technical Education
            </p>
            <p class="aboutme-texts">
            Completed CodeClan's intensive software development course. 
            Development languages, databases, testing and methodologies. 
            Daily pair programming exercises. For group projects, we followed Agile methodology, 
            running regular stand-ups while organising collaborative work using Trello board and Github. 
            Completed Professional Development Award: Software Development at Level 8.
            </p>
            <p class="aboutme-headline">
                Currently I am:
            </p>
            <p class="aboutme-texts">        
            Tech support volunteer for  <a href="https://abilitynet.org.uk/" target="_blank">
              <strong>AbilityNet</strong></a><br/>
            Volunteer developer for <a href="https://rnib.org.uk/" target="_blank"><strong>RNIB</strong></a><br/>
            Learning <strong>.NET </strong>, <strong> C# </strong> and <strong>Azure</strong> for my volunteer project
            </p>
             </div>
        </Card.Body>
      </Card>
 
</div>

  );
}

export default AboutMe;







